module.exports = __webpack_public_path__ + "img/4-2-4-3-5-preview-scott-e.ffa62912.jpg";